import _regenerator from "/var/jenkins_home/workspace/crm-admin-uat/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/crm-admin-uat/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import { getMsg, sendMsg as _sendMsg } from '@/api/admissionCounseling/customerDrawerCom';
import moment from 'moment';
export default {
  name: 'MsgInviteCom',
  props: {
    cId: {
      type: Number,
      required: true
    }
  },
  data: function data() {
    return {
      data: {},
      msg: {
        isExist: false,
        visible: false,
        phone: '',
        loading: false
      },
      rules: {
        phone: [{
          required: true,
          trigger: 'blur',
          message: '请选择手机号发送短信邀请'
        }]
      },
      time: '',
      timeId: undefined
    };
  },
  watch: {
    cId: function cId() {
      this.init();
    }
  },
  created: function created() {
    this.init();
  },
  beforeDestroy: function beforeDestroy() {
    this.clearTimer();
  },
  methods: {
    init: function init() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var cId, clearTimer, res, data;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              cId = _this.cId, clearTimer = _this.clearTimer;
              clearTimer();
              _context.n = 1;
              return getMsg(cId);
            case 1:
              res = _context.v;
              data = res.data;
              _this.data = data;
              if (data.isProtection) {
                _this.timeId = setInterval(function () {
                  var _moment$duration$_dat = moment.duration(moment(data.protectionTime).diff(moment()))._data,
                    days = _moment$duration$_dat.days,
                    hours = _moment$duration$_dat.hours,
                    minutes = _moment$duration$_dat.minutes,
                    seconds = _moment$duration$_dat.seconds;
                  _this.time = days ? "".concat(days, "\u5929").concat(hours, ":").concat(minutes, ":").concat(seconds) : "".concat(hours, ":").concat(minutes, ":").concat(seconds);
                }, 1000);
              }
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    handleClickByMsg: function handleClickByMsg() {
      var data = this.data,
        $message = this.$message,
        handleMsgDialogVisible = this.handleMsgDialogVisible;
      var isConfiguration = data.isConfiguration,
        isOpenUsed = data.isOpenUsed,
        number = data.number,
        used = data.used;
      if (isConfiguration) {
        if (isOpenUsed && used >= number) {
          $message({
            type: 'warning',
            message: '今日发送额度已满',
            duration: 2000
          });
        } else {
          handleMsgDialogVisible();
        }
      } else {
        $message({
          type: 'warning',
          message: '你暂未配置短信链接，请联系管理员',
          duration: 2000
        });
      }
    },
    handleMsgDialogVisible: function handleMsgDialogVisible() {
      var msg = this.msg;
      !msg.isExist && (msg.isExist = true);
      msg.visible = !msg.visible;
    },
    handleSend: function handleSend() {
      var $refs = this.$refs,
        sendMsg = this.sendMsg;
      $refs['msg'].validate(function (isPass) {
        if (isPass) {
          sendMsg();
        } else {
          return false;
        }
      });
    },
    sendMsg: function sendMsg() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var handleLoading, msg, cId, $message, handleMsgDialogVisible, init, res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              handleLoading = _this2.handleLoading, msg = _this2.msg, cId = _this2.cId, $message = _this2.$message, handleMsgDialogVisible = _this2.handleMsgDialogVisible, init = _this2.init;
              handleLoading();
              _context2.n = 1;
              return _sendMsg({
                id: cId,
                phone: msg.phone
              }).finally(function () {
                handleLoading();
                handleMsgDialogVisible();
              });
            case 1:
              res = _context2.v;
              if (res.code === 200) {
                $message({
                  type: 'success',
                  message: '发送请求已成功'
                });
                init();
              }
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    handleLoading: function handleLoading() {
      var msg = this.msg;
      msg.loading = !msg.loading;
    },
    clearTimer: function clearTimer() {
      var timeId = this.timeId;
      timeId && clearInterval(timeId);
    }
  }
};